const customMethods = {
    run : function () {
        this.init();
        this.appHeight();
        this.wowo();
        this.resourcesFun();
        this.marqueeInit();
        this.marquee();
        this.slider();
        this.sliderArrowPosition();
        this.headerMenu();
        this.highlightBoxHeight();
        this.highlightBoxShowMore();
        this.accordionFun();
        this.shareLink();
        this.anchorLink();
        this.anchorTitleHighlight();
        this.inputFocus();
        this.selectFun();
        this.sortDropdown();
        this.setContactForm();
        this.sizePop();
        this.blockToggle();
        this.faqSearch();
        this.shopBannerFilters();
        this.stickyMenuSetCurrent();
        this.videoPop();
    },
    
    // Initialization work
    init : () => {
        jQuery('html').addClass("show-c");

        if(jQuery('.default-content-block').length){
            jQuery('.default-content-block').parent('section').css('overflow', 'visible');
            if(jQuery('.default-content-block .default-content h2').length){
                var count = 0;
                jQuery('.default-content-block .content').prepend('<aside></aside>');
                jQuery('.default-content-block .default-content h2').each(function(){
                    let title = jQuery(this).text();
                    jQuery(this).addClass('anchor-title').attr('id','section-' + count).attr('data-index',count);
                    jQuery('.default-content-block .content aside').append('<a href="#section-' + count + '">' + title + '</a>');
                    count++;
                });
            }else{
                jQuery('.default-content-block .content').addClass('no-h2');
            }
            jQuery('.default-content-block .content').css('opacity', '1');
        }

        if(jQuery('section.product-details').length){
            jQuery('section.product-details').parent('section').addClass('product-details-section-template');
        }
    },

    // Calculate screen height by ignoring the height of the toolbar
    appHeight : () => {
        const doc = document.documentElement;
        doc.style.setProperty('--vh', (jQuery(window).innerHeight() * .01) + 'px');

        if(jQuery('footer').hasClass('footer-fixed')){
            var doucmentHeight = jQuery('body').height() + jQuery('footer').outerHeight();;
        }else{
            var doucmentHeight = jQuery('body').height();
        }
        let windowHeight = jQuery(window).height();

        if(doucmentHeight < windowHeight){
            jQuery('footer').addClass('footer-fixed');
        }else{
            jQuery('footer').removeClass('footer-fixed');
        }
    },
    
    // Entry animation
    wowo : () => {
        setTimeout(function () {
            let wTop = jQuery(window).scrollTop(), wHeight = jQuery(window).height(), wBottom = wTop + wHeight;

            jQuery(".wowo:not(.animated)").each(function () {
                let me = jQuery(this), 
                    meTop = me.offset().top, 
                    meHeight = me.height(), 
                    meBottom = meTop + meHeight,
                    limitTop = wTop - meHeight, 
                    limitBottom = wBottom + meHeight;

                if (meTop > limitTop && meBottom < limitBottom) {
                    me.addClass("animated");
                    setTimeout(() => {
                        me.removeClass("animated wowo");
                    }, 1500);
                }
            })
        }, 100);
    },

    videoPop : function () {
        jQuery('body').on('click','.has-video-pop',function(e){
            e.preventDefault();
            let video = jQuery(this).find('.video-pop-content').html();
            console.log(video);

            jQuery('main').append('<div class="program-video-pop"><div class="icon-close"></div><div class="container">' + video + '</div></div>');
            jQuery('.program-video-pop').fadeIn(300);
        })
        jQuery('body').on('click','.program-video-pop .icon-close',function(e){
            jQuery('.program-video-pop').fadeOut(300);
            setTimeout(() => {
                jQuery('.program-video-pop').remove();
            }, 300);
        })
    },

    resourcesFun : function () {
        jQuery('body').on('click',function(){
            jQuery('.res-filter-wrapper').find('ul').slideUp(300);
            jQuery('.res-filter-wrapper').removeClass('is-open');
        })

        jQuery('body').on('click','.res-filter-wrapper',function(e){
            jQuery(this).find('ul').slideToggle(300);
            jQuery(this).toggleClass('is-open');
            jQuery(this).siblings('.res-filter-wrapper').find('ul').slideUp(300);
            jQuery(this).siblings('.res-filter-wrapper').removeClass('is-open');

            e.stopPropagation();
        })

        jQuery('body').on('click','.res-filter-wrapper li',function(e){
            jQuery(this).toggleClass('active');
            e.stopPropagation();
        })

        // if(jQuery('.resources-data-box').length){
        //     let res = [];
        //     jQuery('.resources-data-box .item').each(function(){
        //         res.push(jQuery(this).html());
        //     })
        //     console.log(res.length);
        //     let results = jQuery('.resources-data-box').html();

        //     jQuery('.resources-list').html(results);
        // }
    },
    
    // Header interactional
    headerMenu : function () {
        jQuery('body').on('click', '.hamburger', function () {
            jQuery('html').toggleClass('body-hidden');
            jQuery('header').toggleClass('menu-open');
            if(jQuery('header').hasClass('menu-open')){
                jQuery('.header-menu').addClass('transition-able');
            }else{
                setTimeout(() => {
                    jQuery('.header-menu').removeClass('transition-able');
                }, 800);
            }
        })

        jQuery('body').on('mouseenter','.header-main nav>ul>li>a',function(){
            if(jQuery(window).width() > 991){
                jQuery(this).addClass('is-hover').siblings('ul').fadeIn(300);
                jQuery(this).addClass('is-hover').siblings('.mega-menu-wrap').fadeIn(300);
                if(jQuery(this).siblings().hasClass('mega-menu-wrap')){
                    jQuery('header').addClass('white-bg');
                }
            }
        })

        jQuery('body').on('mouseleave','.header-main nav>ul>li',function(){
            if(jQuery(window).width() > 991){
                jQuery(this).children('ul').fadeOut(300);
                jQuery(this).children('.mega-menu-wrap').fadeOut(300);

                jQuery(this).find('a').removeClass('is-hover');
                jQuery('header').removeClass('white-bg');
            }
        })

        jQuery('body').on('click','.search-toggle',function(e){
            jQuery('html').addClass('body-hidden');
            jQuery('.search-pop').fadeIn(300);
            jQuery('.search-pop input[type="text"]').focus();

            e.stopPropagation();
            return false;
        })

        jQuery('body').on('click','.header__icon--search',function(e){
            jQuery('html').addClass('body-hidden');
            jQuery('.search-modal').fadeIn(300);
            jQuery('.search-modal input.search__input').focus();

            e.stopPropagation();
            return false;
        })

        jQuery('body').on('click','.search-pop form',function(e){
            e.stopPropagation();
        })

        jQuery('body').on('click','.search-pop .icon-close',function(){
            jQuery('.search-pop').fadeOut(300);
            jQuery('html').removeClass('body-hidden');
        })

        jQuery('body').on('click','.search-modal .search-modal__close-button',function(){
            jQuery('.search-modal').fadeOut(300);
            jQuery('html').removeClass('body-hidden');
            jQuery('body').removeClass('gl-search-open');
        })

        jQuery('header nav>ul>li').each(function(){
            if(jQuery(this).find('ul').length){
                // jQuery(this).addClass('has-submenu');
            }
        })

        jQuery('body').on('click','.has-submenu',function(){
            if(jQuery(window).width() < 992){
                jQuery(this).toggleClass('show-submenu').siblings().removeClass('show-submenu');
                jQuery(this).children('ul').slideToggle(300);
                jQuery(this).siblings().children('ul').slideUp(300);
                jQuery(this).siblings().children('.mega-menu-wrap').slideUp(300);
            }
        });
        jQuery('body').on('click','.has-megamenu',function(){
            if(jQuery(window).width() < 992){
                jQuery(this).toggleClass('show-submenu').siblings().removeClass('show-submenu');
                jQuery(this).children('.mega-menu-wrap').slideToggle(300);
                jQuery(this).siblings().children('.mega-menu-wrap').slideUp(300);
                jQuery(this).siblings().children('ul').slideUp(300);
            }
        });

        jQuery('body').on('click','.has-submenu>ul',function(e){
            e.stopPropagation();
        })
        jQuery('body').on('click','.has-megamenu>.mega-menu-wrap',function(e){
            e.stopPropagation();
        })
    },

    // Sticky header
    headerSticky : () => {
        if (jQuery(document).scrollTop() > 60){
            jQuery('header').addClass('sticky');
        } else {
            jQuery('header').removeClass('sticky');
        }
    },
    
    // Scroll page
    pageScroll : (position , diff = 0) => {
        jQuery('html,body').animate({scrollTop:position - diff},800);
    },

    // Anchor link scroll effect
    anchorLink : function () {
        let _this = this;

        let currentLocation = window.location.href;
        if(currentLocation.search('#articles') > 0){
            jQuery('html,body').animate({scrollTop:0},0);

            let anchorPosition = jQuery('#articles').offset().top,
            headerHeight = jQuery('header').outerHeight();

            _this.pageScroll(anchorPosition,100);
        }

        if(currentLocation.search('#bg-card-content') > 0){
            let anchorPosition = jQuery('.bg-card-content').offset().top,
            headerHeight = jQuery('header').outerHeight();

            _this.pageScroll(anchorPosition,headerHeight);
        }

        if(currentLocation.search('#story-') > 0){
            let story = currentLocation.split('#story-')[1];
            let anchorPosition = jQuery('.story-list .item').eq(story - 1).offset().top,
            headerHeight = jQuery('header').outerHeight();

            _this.pageScroll(anchorPosition,headerHeight);
        }

        jQuery('body').on('click','a:not([href="#recover"],[href="#login"])',(e) => {
            if(jQuery(e.target.hash).length){
                e.preventDefault();
                let anchorPosition = jQuery(e.target.hash).offset().top,
                    headerHeight = jQuery('header').outerHeight();

                _this.pageScroll(anchorPosition,100);
            }
        });

        jQuery('body').on('click','.inner-banner .scroll-btn',() => {
            let anchorPosition = jQuery(window).height();

            _this.pageScroll(anchorPosition,64,500);
        });

        jQuery('body').on('click','.default-content .back-to-top',function(){
            _this.pageScroll(0,0,800);
            return false;
        });
    },

    anchorTitleHighlight : function () {
        jQuery('.anchor-title').each(function(){
            var i = jQuery(this).attr('data-index'),
                me = jQuery(this),
                meTop = me.offset().top,
                scrollTop = jQuery(document).scrollTop();
            
            if(scrollTop > meTop - 300){
                jQuery('aside a').eq(i).addClass('active');
                jQuery('aside a').eq(i).addClass('active');
                for(let j = 0; j < i; j++){
                    jQuery('aside a').eq(j).removeClass('active');
                }
            }else{
                jQuery('aside a').eq(i).removeClass('active');
            }
        });
    },
    
    inputFocus : function () {
        jQuery('body').on('focus','.input-item input',function(){
            jQuery(this).parent('.input-item').addClass('focus');
        })

        jQuery('body').on('blur','.input-item input',function(){
            if(jQuery(this).val() == ''){
                jQuery(this).parent('.input-item').removeClass('focus');
            }
        })
    },

    selectFun : function () {
        jQuery('.select-placeholder').each(function(){
            jQuery(this).siblings('select').val('');
        });

        jQuery('body').on('change','.select-item select',function(){
            if(jQuery(this).siblings('.select-placeholder').length){
                jQuery(this).siblings('.select-placeholder').hide();
            }
        });
    },

    sortDropdown : function () {
        jQuery('body').on('click','.sort-toggle',function(e){
            jQuery(this).siblings('.sort-options').stop().slideToggle(300);
            e.stopPropagation();
        })

        jQuery('body').on('click','.sort-options li',function(){
            let sortText = jQuery(this).text();
            jQuery('.sort-toggle').text(sortText);
        })
        
        jQuery('body').on('click',function(){
            jQuery('.sort-options').slideUp(300);
        })
    },

    sizePop : function () {
        jQuery('body').on('click','.size-guide-toggle',function(){
            jQuery('.sizing-chart-pop').fadeIn(300);
            jQuery('html').addClass('body-hidden');
        })

        jQuery('body').on('click','.name-option[data-name="Size"] .name-variant',function(){
            jQuery('.sizing-chart-pop').fadeIn(300);
            jQuery('html').addClass('body-hidden');
        })

        jQuery('body').on('click','.sizing-scroll',function(e){
            e.stopPropagation();
        })
        
        jQuery('body').on('click','.sizing-chart-pop',function(){
            jQuery('html').removeClass('body-hidden');
            jQuery(this).fadeOut(300);
        })
        jQuery('body').on('click','.close-sizing-popup',function(){
            jQuery('html').removeClass('body-hidden');
            jQuery(this).parents('.sizing-chart-pop').fadeOut(300);
        })
        

        jQuery('body').on('click','.large-product-img-slider .item',function(){
            if(jQuery('.pop-large-imgs').length){
                let pointIndex = jQuery(this).index();
                jQuery('.pop-large-imgs').slick('slickGoTo',pointIndex);
    
                jQuery('.product-imgs-pop').addClass('show-img-pop');
                jQuery('header').css('pointer-events','none');
                jQuery('html').addClass('body-hidden');
            }
        })
        
        jQuery('body').on('click','.product-imgs-pop .icon-close',function(e){
            jQuery('html').removeClass('body-hidden');
            jQuery('header').css('pointer-events','all');
            jQuery('.product-imgs-pop').removeClass('show-img-pop');
            e.stopPropagation();
        })
    },

    blockToggle : function () {
        jQuery('body').on('click','.our-story .story-nav p',function(){
            let i = jQuery(this).index();
            jQuery(this).addClass('active').siblings().removeClass('active');
            jQuery('.story-list:not(.slick-view) .item').eq(i).fadeIn(300).siblings().hide();
        })

        jQuery('body').on('click','.job-perks .nav-list span',function(){
            let i = jQuery(this).index();
            jQuery(this).addClass('active').siblings().removeClass('active');
            jQuery('.job-perks .list').eq(i).fadeIn(500).css('display','flex').siblings().hide();
        })
        var isStory = location.hash;
        if (isStory.indexOf('story') !== -1) {
            jQuery('html,body').animate({scrollTop:jQuery('.our-story').offset().top},500);
            var parts = isStory.split('story-'); 
            var partIndex = parseInt(parts[1]) - 1;
            jQuery('.story-nav').children().eq(partIndex).trigger('click');
        }
    },

    highlightBoxHeight : function () {
        jQuery('.highlight-box').each(function(){
            let height = jQuery(this).find('.inner-text-box').outerHeight();
            jQuery(this).find('.inner-content').attr('style','--more-height:' + height + 'px;');

            if(height <= 199){
                jQuery(this).find('.inner-content').addClass('no-more');
            }else{
                jQuery(this).find('.inner-content').removeClass('no-more');
            }
        });
    },

    highlightBoxShowMore : function () {
        jQuery('body').on('click','.highlight-box .show-more', function(){
            jQuery(this).parents('.highlight-box').toggleClass('active');
        })
    },

    accordionFun : function () {
        jQuery('body').on('click','.accordion-item-head',function(){
            jQuery(this).parent().toggleClass('active').siblings().removeClass('active');
            jQuery(this).siblings().stop().slideToggle(300);
            jQuery(this).parent().siblings().find('.accordion-item-body').slideUp(300);
        });

        jQuery('body').on('click','.faq-item .item-head',function(){
            jQuery(this).parent().toggleClass('active').siblings().removeClass('active');
            jQuery(this).siblings().stop().slideToggle(300);
            jQuery(this).parent().siblings().find('.item-body').slideUp(300);
        });

        jQuery('body').on('click','.brand-accordion-block .text-head',function(){
            jQuery(this).parent().toggleClass('active');
            jQuery(this).siblings('.text-body').slideToggle(300);
        });
    },

    faqSearch: function () {
        jQuery('body').on('click','.faq-banner .search-submit input',function(){
            var text = jQuery('#faq-key').val();
            var key = jQuery('#faq-key').val().toLowerCase();
            if(key != ''){
                jQuery('.faqs-category-block .faq-item').each(function(){
                    let itemTitle = jQuery(this).find('.item-head p').text().toLowerCase();
                    if(itemTitle.search(key) >= 0){
                        jQuery(this).addClass('fit').show();
                    }else{
                        jQuery(this).removeClass('fit').hide();
                    }
                });

                jQuery('.faqs-category-block').each(function(){
                    if(jQuery(this).find('.fit').length){
                        jQuery(this).addClass('fit').show();
                    }else{
                        jQuery(this).removeClass('fit').hide();
                    }
                });

                if(jQuery('.faqs-category-block.fit').length){
                    jQuery('.faq-no-results').hide();
                    if(jQuery('.faqs-category-block.fit').length>1){
                        jQuery('.result-tips').text('Showing '+jQuery('.faqs-category-block.fit').length+' results for "'+text+'"');
                    }else{
                        jQuery('.result-tips').text('Showing '+jQuery('.faqs-category-block.fit').length+' result for "'+text+'"');
                    }

                }else{
                    var key = jQuery('.faq-no-results span').text(key);
                    jQuery('.faq-no-results').show();
                    jQuery('.result-tips').text('No results for "'+text+'"');

                }
                jQuery('.result-tips').addClass('is-show');
                

            }else{
                jQuery('.faqs-category-block').show();
                jQuery('.faqs-category-block .faq-item').show();
                jQuery('.faq-no-results').hide();
                jQuery('.result-tips').removeClass('is-show');
            }
         
            return false;
        })
    },
    shopBannerFilters : function () {
        jQuery('.best-sellers-banner .btn-white').click(function(e){
            e.preventDefault();
            var filter = jQuery(this).attr('href');
            var newStr = filter.slice(1);
            // console.log(newStr);
            jQuery('#gf-tree').find('[data-fvalue="'+newStr+'"]:not(.checked)').trigger('click');
        });
    },
    setContactForm : function () {
        window.onload=function(){
            var contactType = location.hash;
            if(contactType){
                var newString = contactType.slice(1);
                const decodedURL = decodeURI(newString);
                console.log(decodedURL);
                jQuery('select[name="select-1"]').val(decodedURL);
            }
        }
    },


    marqueeInit : function () {
        if (jQuery(".featured-logos-row").length > 0) {
            jQuery('.featured-logos-row .wrapper:first-child .item').each(function(){
                let img = jQuery(this).find('img');
                let imgWidth = img[0].naturalWidth *  0.5; 
                let imgMobileWidth = imgWidth * 0.783; 
                jQuery(this).attr('style','--desktop-width:' + imgWidth + 'px;--mobile-width:' + imgMobileWidth + 'px;');
            })  
            
            let rowWidth = 0;
            jQuery('.featured-logos-row .wrapper:first-child .item').each(function(){
                let itemWidth = jQuery(this).outerWidth();
                rowWidth += itemWidth;
            }) 
            jQuery('.featured-logos-row .wrapper').css('min-width',rowWidth);
        }

        if (jQuery(".img-scroller").length > 0) {
            jQuery('.img-scroller .wrapper:first-child .item').each(function(){
                let img = jQuery(this).find('img');
                let imgWidth = img[0].naturalWidth *  0.5; 
                let imgMobileWidth = imgWidth * 0.64; 
                jQuery(this).attr('style','--desktop-width:' + imgWidth + 'px;--mobile-width:' + imgMobileWidth + 'px;');
            })  
            
            let rowWidth = 0;
            jQuery('.img-scroller .wrapper:first-child .item').each(function(){
                let itemWidth = jQuery(this).outerWidth();
                rowWidth += itemWidth;
            }) 
            jQuery('.img-scroller .wrapper').css('min-width',rowWidth);
        }
    },

    marquee : function(){
        let _this = this;
        if (jQuery(".featured-logos-row").length > 0) {
            Marquee3k.init({
                selector: 'marquee'
            });
            setTimeout(() => {
                _this.marqueeInit();
            }, 300);
        }

        if (jQuery(".img-scroller").length > 0) {
            Marquee3k.init({
                selector: 'img-scroller'
            });
            setTimeout(() => {
                _this.marqueeInit();
            }, 300);
        }
    },

    // Sliders
    slider : function () {
        if(jQuery('.text-image-block .img-box .img-item').length > 0){  
            jQuery('.text-image-block .img-box .img-item').each(function(){
                if(jQuery(this).find('img').length > 1){
                    jQuery(this).slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        fade: true,
                        arrows: false,
                        dots: false,
                        autoplay: true,
                        pauseOnHover: false,
                        pauseOnFocus: false,
                        infinite: true,
                        speed: 500,
                        autoplaySpeed: 8000
                    });
                }
            })
        }
        
        if(jQuery('.recommended-products .list').length > 0){  
            jQuery('.recommended-products .list').each(function(){
                jQuery(this).slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    fade: false,
                    arrows: true,
                    dots: false,
                    autoplay: true,
                    pauseOnHover: true,
                    pauseOnFocus: true,
                    infinite: true,
                    speed: 500,
                    autoplaySpeed: 5000,
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 2,
                            }
                        },
                        {
                            breakpoint: 575,
                            settings: {
                                slidesToShow: 1,
                            }
                        }
                    ]
                });
            })
        }
        if(jQuery('.product-slider').length > 0){  
            jQuery('.product-slider').each(function(){
                jQuery(this).slick({
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    fade: false,
                    arrows: true,
                    dots: false,
                    autoplay: true,
                    pauseOnHover: true,
                    pauseOnFocus: true,
                    infinite: true,
                    speed: 500,
                    autoplaySpeed: 5000,
                    responsive: [
                        {
                            breakpoint: 991,
                            settings: {
                                slidesToShow: 2,
                            }
                        },
                        {
                            breakpoint: 575,
                            settings: {
                                slidesToShow: 1,
                            }
                        }
                    ]
                });
            })
        }

        if(jQuery('.story-list').length > 0){  
            jQuery('.story-list.slick-view').each(function(){
                jQuery(this).slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    fade: true,
                    arrows: true,
                    dots: true,
                    adaptiveHeight: true,
                    autoplay: false,
                    pauseOnHover: true,
                    pauseOnFocus: true,
                    infinite: true,
                    speed: 500,
                    autoplaySpeed: 5000
                });

                let dotsWidth = jQuery(this).find('.slick-dots').outerWidth();
                if(dotsWidth > 0){
                    jQuery(this).addClass('width-init').attr('style','--dots-width:' + dotsWidth / 2 + 'px;');
                }
            })
        }

        if(jQuery('.program-list.slick-view').length > 0) {
            jQuery('.program-list.slick-view').each(function(){
                jQuery(this).slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    fade: true,
                    arrows: true,
                    dots: true,
                    autoplay: true,
                    pauseOnHover: true,
                    pauseOnFocus: true,
                    infinite: true,
                    speed: 500,
                    autoplaySpeed: 5000
                });

                let dotsWidth = jQuery(this).find('.slick-dots').outerWidth();
                if(dotsWidth > 0){
                    jQuery(this).addClass('width-init').attr('style','--dots-width:' + dotsWidth / 2 + 'px;');
                }
            })
        }

        if(jQuery('.large-product-img-slider').length > 0){  
            if(jQuery('.large-product-img-slider .item').length > 1){
                const imgs = jQuery('.large-product-img-slider').html(),
                      largeImgList = '<div class="pop-large-imgs"></div>';

                jQuery('.product-details').append('<div class="product-imgs-pop"><div class="pop-wrapper"><div class="imgs-group"><i class="icon-close"></i></div></div></div>');
                jQuery('.product-details .product-imgs-pop .imgs-group').append(largeImgList);
                jQuery('.pop-large-imgs').html(imgs);
     
                jQuery('.pop-large-imgs').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    swipe: false,
                    fade: true,
                    arrows: true,
                    dots: false,
                    autoplay: false,
                    pauseOnHover: true,
                    pauseOnFocus: true,
                    infinite: true,
                    speed: 500,
                    autoplaySpeed: 5000
                });

                jQuery('.pop-large-imgs').find('.item').each(function(){
                    var img = jQuery(this).find('img').attr('src')
                    jQuery(this).append('<div class="large-view"><img src="'+img+'" data-x="0" data-y="0"></div>');
                });

                // jQuery('body').on('mousedown','.large-show .large-view',function(e){


                jQuery('body').on('click','.pop-large-imgs .item',function(event){
                    jQuery(this).addClass('large-show');
                });
               
                var isDragging = false;
                // var draggable = jQuery('.large-show .large-view');
                var startX, startY, offsetX, offsetY,imgsetX,imgsetY;


                jQuery('body').on('mousedown','.large-show .large-view',function(e){
                    var draggable = jQuery(this);
                    isDragging = true;
                    startX = e.clientX, startY = e.clientY;
                    offsetX = jQuery(this).offset().left, 
                    offsetY = jQuery(this).offset().top;
                    imgsetX = parseInt(jQuery(this).find('img').attr('data-x')),
                    imgsetY = parseInt(jQuery(this).find('img').attr('data-y'));
                });

                jQuery('body').on('mousemove','.large-show .large-view',function(e){
            
                    var draggable = jQuery(this);
                    if (isDragging) {
                        var itemWidth = draggable.find('img').width();
                        var itemHeight = draggable.find('img').height();
                        var maxx = 3*itemWidth/8,
                            minx= -3*itemWidth/8,
                            maxy= 3*itemHeight/8,
                            miny= -3*itemHeight/8;
                        var xm = e.clientX - startX + imgsetX;
                        var ym = e.clientY - startY + imgsetY;
                        if(xm>maxx){
                            xm = maxx;
                        }
                        if(xm<minx){
                            xm = minx;
                        }
                        if(ym>maxy){
                            ym = maxy;
                        }
                        if(ym<miny){
                            ym = miny;
                        }
                        draggable.find('img').css('transform','translate('+xm+'px,'+ym+'px)').attr('data-x',xm).attr('data-y',ym);
                    }
                });
                jQuery('body').on('mouseup','.large-view',function(e){
                    e.stopPropagation();
                    e.preventDefault();
                    isDragging = false;
                });
                // jQuery('body').on('click','.large-view',function(event){
                //     console.log(2024);
                //     event.stopPropagation();
                // });

                // jQuery('body').on('click','.large-view',function(){
                //     jQuery(this).toggleClass('large-show');
                // })


            }

            jQuery('.large-product-img-slider').each(function(){
                if(jQuery(this).find('.item').length > 1){
                    jQuery(this).slick({
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        fade: true,
                        arrows: true,
                        dots: false,
                        autoplay: false,
                        pauseOnHover: true,
                        pauseOnFocus: true,
                        infinite: true,
                        speed: 500,
                        autoplaySpeed: 5000,
                        draggable: false,
                        asNavFor: '.small-product-img-slider'
                    });
                }
            })
        }

        if(jQuery('.small-product-img-slider').length > 0){ 
            if(jQuery('.small-product-img-slider .item').length > 7){
                var infiniteSet = true;
            }else{
                var infiniteSet = false;
            }
            if(jQuery('.small-product-img-slider .item').length == 1){
                jQuery('.small-product-img-slider').addClass('only-one');
            }
            jQuery('.small-product-img-slider').each(function(){
                jQuery(this).slick({
                    slidesToShow: 7,
                    slidesToScroll: 7,
                    variableWidth: true,
                    fade: false,
                    arrows: false,
                    dots: false,
                    autoplay: false,
                    pauseOnHover: true,
                    pauseOnFocus: true,
                    infinite: infiniteSet,
                    speed: 500,
                    autoplaySpeed: 5000,
                    focusOnSelect: true,
                    asNavFor: '.large-product-img-slider'
                });
            })
        }

        if(jQuery('.categories-slider').length > 0){  
            jQuery('.categories-slider').each(function(){
                jQuery(this).slick({
                    slidesToShow: 4,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: false,
                    autoplay: false,
                    pauseOnHover: true,
                    pauseOnFocus: true,
                    infinite: true,
                    speed: 500,
                    autoplaySpeed: 5000,
                    responsive: [
                        {
                            breakpoint: 767,
                            settings: {
                                slidesToShow: 3,
                            }
                        },
                        {
                            breakpoint: 575,
                            settings: {
                                slidesToShow: 2,
                            }
                        }
                    ]
                });
            })
        }

        if(jQuery('.feature-callout .text-slider').length > 0){  
            jQuery('.feature-callout .text-slider').each(function(){
                jQuery(this).slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: true,
                    fade: true,
                    arrows: true,
                    dots: false,
                    autoplay: false,
                    pauseOnHover: true,
                    pauseOnFocus: true,
                    infinite: true,
                    speed: 500,
                    autoplaySpeed: 5000,
                });

                jQuery(this).on('beforeChange',function(event,slick,currentSlide,nextSlide){
                    jQuery(this).parents('.feature-callout').find('.dot-item').eq(nextSlide).addClass('active').siblings().removeClass('active');
                })

                jQuery('body').on('click','.feature-callout .dot-item',function(){
                    let i = jQuery(this).index();
                    jQuery(this).parents('.feature-callout').find('.text-slider').slick('slickGoTo',i);
                })
            })
        }

        if(jQuery('.featured-videos .articles-list').length > 0){
            jQuery('.featured-videos .articles-list').slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                adaptiveHeight: true,
                arrows: true,
                dots: false,
                autoplay: false,
                pauseOnHover: false,
                pauseOnFocus: false,
                infinite: true,
                speed: 500,
                autoplaySpeed: 5000,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 575,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            });
        }

        var touchStartTime;

        jQuery('.slick-slider a').on('touchstart', function() {
            touchStartTime = new Date().getTime();
        });

        jQuery('.slick-slider a').on('touchend', function(e) {
            var touchEndTime = new Date().getTime();
            if (touchEndTime - touchStartTime > 200) {
                e.preventDefault();
            }
        });
    },

    sliderArrowPosition : function () {
        jQuery('.product-slider').each(function () {
            let offsetTop = jQuery(this).find('.product-item .card__inner').outerHeight() / 2 - jQuery(this).find('.slick-arrow').outerHeight() / 2;
            jQuery(this).attr('style','--arrow-offset-top:' + offsetTop + 'px;');
        })
    },

    shareLink : function () {
        let _this = this;

        jQuery('body').on('click','.share-link',function(){
            if(!jQuery(this).hasClass('copied')){
                let link = window.location.href;
                _this.copyLink(link);

                jQuery(this).addClass('copied');
                setTimeout(() => {
                    jQuery(this).removeClass('copied');
                }, 600);
            }

            return false;
        })
    },

    copyLink : (copy_val) => {
        const input = document.createElement('input');
        input.setAttribute('readonly', 'readonly');
        input.setAttribute('value', copy_val);
        document.body.appendChild(input);
        input.setSelectionRange(0, 9999);
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
    },
    stickyMenuSetCurrent : function () {
        if(jQuery('.press-nav-bar').length){
            let wTop = jQuery(window).scrollTop(), wHeight = jQuery(window).height(), wBottom_half = wTop + (wHeight/2);
            jQuery('section').each(function() {
                if(wBottom_half>jQuery(this).offset().top){
                    var id = jQuery(this).attr('id');
                    jQuery('.press-nav-bar').find('a[href="#'+id+'"]').siblings().removeClass('active');
                    jQuery('.press-nav-bar').find('a[href="#'+id+'"]').addClass('active');
                }
            });
        }
    }
    
}

jQuery(document).ready(function() {
    if (window.location.hash) {

        setTimeout(function () {
            window.scrollTo(0, 0); 
        }, 1);
    }


    var hash = window.location.hash;
    if (hash) {
        var target = jQuery(hash); 
        if (target.length) {
        setTimeout(function () {
            jQuery('html, body').animate({
                scrollTop: target.offset().top - 100
            }, 800); 
        }, 100);
        }
    }
  
    customMethods.run();
    customMethods.headerSticky();

    // jQuery('a:not([href="#recover"],[href="#login"],[href="/cart"])').on('touchend', function(e) {
    //     var el = $(this);
    //     var link = el.attr('href');
    //     window.location = link;
    // });
});

jQuery(window).scroll(function() {
    customMethods.stickyMenuSetCurrent();
    customMethods.wowo();
    customMethods.headerSticky();
    customMethods.anchorTitleHighlight();

    if(jQuery('.sw-instagram-col .sw-instagram-item-img img').length){
        jQuery('.sw-instagram-row:not(.slick-initialized)').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            fade: false,
            arrows: true,
            dots: false,
            autoplay: false,
            pauseOnHover: true,
            pauseOnFocus: true,
            infinite: true,
            speed: 500,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 2,
                    }
                }
            ]
        });
        jQuery('.sw-instagram-body').css('opacity','1').css('position','static');
    } 
});

jQuery(window).resize(function () {
    customMethods.appHeight();
    customMethods.highlightBoxHeight();
    customMethods.marqueeInit();

    setTimeout(() => {
        customMethods.sliderArrowPosition();
    }, 300);

    if(jQuery(window).width() > 767){
        jQuery('html').removeClass('body-hidden');
        jQuery('header').removeClass('menu-open');
    }

    if(jQuery('.slick-view:not(.width-init)').length > 0) {
        jQuery('.slick-view:not(.width-init)').each(function(){
            let dotsWidth = jQuery(this).find('.slick-dots').outerWidth();
            if(dotsWidth > 0){
                jQuery(this).addClass('width-init').attr('style','--dots-width:' + dotsWidth / 2 + 'px;');
            }
        })
    }
});
jQuery(document).ready(function() {
window.onload=function(){
    customMethods.marqueeInit();

    let curLocation = window.location.href.split('#')[1];
    if(curLocation == 'cart'){
        jQuery('#cart-icon-bubble')[0].click();
    }

    // if(jQuery('legend[data-name="Size"]').length){
    //     jQuery('legend[data-name="Size"]').append('<span class="size-guide-toggle">Size Guide</span>');
    // }

    if(jQuery('.sw-instagram-col .sw-instagram-item-img img').length){
        jQuery('.sw-instagram-row:not(.slick-initialized)').slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            fade: false,
            arrows: true,
            dots: false,
            autoplay: false,
            pauseOnHover: true,
            pauseOnFocus: true,
            infinite: true,
            speed: 500,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 575,
                    settings: {
                        slidesToShow: 2,
                    }
                }
            ]
        });
        jQuery('.sw-instagram-body').css('opacity','1').css('position','static');
    } 

    if(jQuery('.gf-actions').length){
        jQuery('.gf-actions').css('opacity', '1');
    }
    if(jQuery('#ProductGridContainer').length){
        jQuery('#ProductGridContainer .collection').css('opacity', '1');
    }

    setTimeout(() => {
        if(jQuery('cart-drawer').length){
            jQuery('cart-drawer').css('opacity', '1');
        } 
    }, 500);
}
});